import { render, staticRenderFns } from "./PageTopBtn.vue?vue&type=template&id=1d6c4413&scoped=true&"
import script from "./PageTopBtn.vue?vue&type=script&lang=js&"
export * from "./PageTopBtn.vue?vue&type=script&lang=js&"
import style0 from "./PageTopBtn.vue?vue&type=style&index=0&id=1d6c4413&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c4413",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jin_macintosh/Documents/www.nosync/yusuugaku/web/public/wp-content/themes/ysk/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d6c4413')) {
      api.createRecord('1d6c4413', component.options)
    } else {
      api.reload('1d6c4413', component.options)
    }
    module.hot.accept("./PageTopBtn.vue?vue&type=template&id=1d6c4413&scoped=true&", function () {
      api.rerender('1d6c4413', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/PageTopBtn.vue"
export default component.exports